import React from 'react';
import { useDefaultTestingNavigate } from 'utils/navigation';
import { useSSOStatus } from 'api/configurations';
import PageBarButton from '../PageBarButton/PageBarButton';

const SSOTestingBarButton: React.FC = () => {
	const { data: ssoStatusData } = useSSOStatus();
	const { navigateToDefaultTesting } = useDefaultTestingNavigate(
		ssoStatusData?.idp?.id,
		ssoStatusData?.method
	);

	return (
		<PageBarButton
			disabled={!navigateToDefaultTesting}
			tooltip={
				navigateToDefaultTesting
					? ''
					: intl.tr('home.testingBarButton.disabledTooltip')
			}
			onClick={() => navigateToDefaultTesting?.()}
			text={intl.tr('general.SSOTesting')}
			data-testid="sso-testing-bar-button"
			rightContent={
				ssoStatusData?.ssoLastSuccessTestTime &&
				intl.tr('home.lastSuccessfulTestLabel', {
					testTime: ssoStatusData.ssoLastSuccessTestTime * 1000
				})
			}
		/>
	);
};

export default SSOTestingBarButton;
